import { Component, HostListener, OnInit } from '@angular/core';
import { MultiLanguageService } from './core/services/multi-language.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './core/services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SectionStateService } from './pages/doctor/services/doctor-state.service';

import { DynamicFormService } from './core/services/dynamic-form.service';
import { TransactionRequirementService } from 'src/app/pages/transaction/services/transaction-requirement.service';
import { TransactionRequirementServiceService } from 'src/app/pages/transaction/services/transaction-requirement-service.service';

import { RequirementReviewService } from './core/services/requirement-review.service';
import { PaymentService } from './core/services/payment.service';
import { MainSearchService } from './core/services/main-search.service';
import { TermsAndConditionsService } from './core/services/terms-and-conditions.service';
import firebase from 'firebase/app';
import 'firebase/database';
import { TransactionService } from './pages/transaction/services/transaction.service';
import { InspectionService } from './pages/transaction-admin/services/inspection.service';
import { SwUpdate } from '@angular/service-worker';
import { BUILD_DATE, BUILD_HASH, APP_VERSION } from './build-info';
import { ScrollToTopService } from './core/services/scroll-to-top.service';
import { SwUpdateService } from './core/services/sw-update.service';

@Component({
	selector: 'prgov-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
	isTwoFactorRoute: boolean = false;

	sidenavItems = [
		{
			label: 'Inicio',
			icon: 'home',
			route: '/'
		},
		{
			label: 'Trámites disponibles',
			icon: 'list',
			route: '/available-transactions',
			hidden: true
		},
		{
			label: 'Mis solicitudes',
			icon: 'description',
			route: '/transactions'
		},
		{
			label: 'Solicitudes',
			icon: 'description',
			route: '/transactions-admin'
		},
		{
			label: 'Mi cuenta',
			icon: 'person',
			route: '/account'
		},
		{
			label: 'Mis perfiles',
			icon: 'people',
			route: '/account/profiles'
		},
		{
			label: 'Mis recibos',
			icon: 'receipt',
			route: '/account/receipts'
		},



	]

	constructor(
		public dynamicFormService: DynamicFormService,
		public transService: TransactionRequirementService,
		public transactionRequirementeService: TransactionRequirementServiceService,
		public transactionService: TransactionService,
		public paymentService: PaymentService,
		public requirementReviewService: RequirementReviewService,
		public mainSearchService: MainSearchService,
		public ml: MultiLanguageService,
		private translate: TranslateService,
		public termsAndConditionsService: TermsAndConditionsService,
		public inspectionService: InspectionService,
		private swUpdate: SwUpdate,
		private scrollToTopService: ScrollToTopService,
		private swUpdateService: SwUpdateService,
		public authService: AuthService,
		private router: Router,
		private sectionStateService: SectionStateService
	) {
		// Enhanced build info display
		console.log('%c🚀 XWORKS v3 - Sistema de Salud Digital', 'background-color: #1976d2; color: white; padding: 8px; border-radius: 4px; font-size: 14px; font-weight: bold;');
		console.log('%c📅 Última compilación: ' + BUILD_DATE, 'background-color: #4caf50; color: white; padding: 4px; border-radius: 3px;');
		console.log('%c🔖 Versión: ' + APP_VERSION + ' | Hash: ' + BUILD_HASH, 'background-color: #ff9800; color: white; padding: 4px; border-radius: 3px;');
		console.log('%c⚡ Service Worker habilitado: ' + this.swUpdate.isEnabled, 'background-color: #9c27b0; color: white; padding: 4px; border-radius: 3px;');

		const firebaseConfig = {
			apiKey: 'AIzaSyA5zUwVYGV8TycM9D7jjewQSclQM8FS78k',
			authDomain: 'xworksv2.firebaseapp.com',
			databaseURL: 'https://xworksv2.firebaseio.com',
			projectId: 'xworksv2',
			storageBucket: '',
			messagingSenderId: '153632502946',
			appId: '1:153632502946:web:240a7b3025f4db07'
		};

		// Initialize Firebase
		firebase.initializeApp(firebaseConfig);

		this.ml.verifyVersion();

		translate.addLangs(['en', 'es']);
		translate.setDefaultLang('es');

		translate.use('es');

		// Service Worker initialization is now handled by SwUpdateService
		// The service automatically handles update detection and applies them

		// Configurar el servicio de scroll to top
		this.scrollToTopService.setupScrollToTop();
	}

	isShow: boolean;
	topPosToStartShowing = 800;
	isDoctorToolsDropdownOpen = false;


	lang: any = 'es';

	@HostListener('window:scroll', ['$event'])
	onScroll(event) {
		this.checkScroll(window.scrollY);
	}

	ngOnInit() {
		// Asegurar que la página empiece arriba desde el principio
		window.scrollTo(0, 0);

		// Cargar el perfil del usuario si está autenticado
		if (this.authService.isLoggedIn()) {
			this.authService.getProfile().then(() => {
				// console.log('Perfil cargado:', this.authService.userProfile);
			}).catch(err => {
				// console.error('Error al cargar perfil:', err);
			});
		}

		// Detectar cuando estamos en la ruta two-factor
		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe((event: NavigationEnd) => {
			this.isTwoFactorRoute = event.url.includes('/two-factor');
		});

	}

	onActivate(event) {
		window.scroll({
			top: 0, // Modificado para llevar siempre arriba del todo
			left: 0,
			behavior: 'smooth'
		});
	}

	checkScroll(scrollPosition) {
		if (scrollPosition >= this.topPosToStartShowing) {
			this.isShow = true;
		} else {
			this.isShow = false;
		}
	}

	gotoTop() {
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	switch() {
		this.lang = (this.lang === 'en') ? 'es' : 'en';

		this.translate.use(this.lang);

		console.log(this.lang);
	}

	getFilteredSidenavItems() {
		// Primero filtramos los elementos ocultos
		const visibleItems = this.sidenavItems.filter(item => !item.hidden);

		// Si el usuario no está autenticado, solo mostrar la opción de inicio
		if (!this.authService.isLoggedIn()) {
			return visibleItems.filter(item => item.label === 'Inicio');
		}
		// Si el usuario es técnico, solo mostrar Solicitudes y Mi cuenta
		if (this.authService.hasRole('tecnico interno')) {
			return visibleItems.filter(item =>
				item.label === 'Solicitudes' || item.label === 'Mi cuenta');
		}
		// De lo contrario, mostrar todas las opciones visibles excepto "Solicitudes" que es solo para técnicos
		return visibleItems.filter(item => item.label !== 'Solicitudes');
	}

	// Métodos para el dropdown de "Mis herramientas" en mobile
	hasDoctorToolsAccess(): boolean {
		return !!(this.authService.hasRole('Doctor') ||
			this.authService.hasRole('Demographic') ||
			this.authService.hasRole('Dispensary') ||
			this.authService.hasRole('Director de Division'));
	}

	hasDoctorRole(): boolean {
		return !!this.authService.hasRole('Doctor');
	}

	hasDemographicsRole(): boolean {
		return !!this.authService.hasRole('Demographic');
	}

	hasPatientSearchRole(): boolean {
		return !!(this.authService.hasRole('Doctor') || this.authService.hasRole('Dispensary'));
	}

	hasDeleteRole(): boolean {
		return !!this.authService.hasRole('Director de Division');
	}

	toggleDoctorToolsDropdown(): void {
		this.isDoctorToolsDropdownOpen = !this.isDoctorToolsDropdownOpen;
	}

	navigateToDoctorTab(tabKey: 'recomendaciones' | 'busqueda' | 'demograficos' | 'borrar'): void {
		let tabIndex = 0;
		switch (tabKey) {
			case 'recomendaciones':
				tabIndex = 0;
				break;
			case 'busqueda':
				tabIndex = 1;
				break;
			case 'demograficos':
				tabIndex = 2;
				break;
			case 'borrar':
				tabIndex = 3;
				break;
			default:
				tabIndex = 0;
		}

		// Cerrar el dropdown
		this.isDoctorToolsDropdownOpen = false;

		// Establecer la tab activa antes de navegar
		this.sectionStateService.setActiveTab('doctor', tabIndex);
		this.sectionStateService.setCurrentView('doctor', 'list');

		// Navegar a /doctor
		this.router.navigate(['/doctor']);
	}
}
